import { PackageInstructions } from './PackageInstructions';
import { PreviewGuidance } from '../PreviewGuidance';
import { useEffect, useState } from 'react';
import { Button, Grid, SpaceBetween } from '@amzn/awsui-components-console';
import { WorkStatus } from '@amzn/awsdev-docs-virtual-smiley-conference-typescript-client';

type PackagesHeaderProps = {
  polling: boolean;
  reject: () => void;
  endpoint?: string;
  onPublishClick: () => void;
  workStatus: WorkStatus;
};
export const PackagesHeader = (props: PackagesHeaderProps) => {
  const [approved, setApproved] = useState(false);

  const [manifestBuilt, setManifestBuilt] = useState(
    props.workStatus === WorkStatus.MANIFEST_BUILT
  );
  const [publishScheduled, setPublishScheduled] = useState(
    props.workStatus === WorkStatus.PUBLISH_SCHEDULED
  );
  useEffect(() => {
    setManifestBuilt(props.workStatus === WorkStatus.MANIFEST_BUILT);
    setApproved(props.workStatus === WorkStatus.REVIEW_APPROVED);
    setPublishScheduled(props.workStatus === WorkStatus.PUBLISH_SCHEDULED);
  }, [props.workStatus]);
  // Add package and Submit have moved next to the package rows (see Packages.tsx).
  // This header now carries only the post-submission actions.
  return (
    <>
      <Grid gridDefinition={[{ colspan: 8 }, { colspan: 4 }]}>
        <PackageInstructions />
        {(!props.polling || approved || manifestBuilt || publishScheduled) && (
          <SpaceBetween alignItems={'end'} size={'m'} direction={'horizontal'}>
            {(manifestBuilt || approved) && (
              <Button
                variant='normal'
                onClick={props.reject}
                disabled={approved}
                data-test-id='update-button'
              >
                Update
              </Button>
            )}
            {(manifestBuilt || approved || publishScheduled) && (
              <SpaceBetween
                size={'xs'}
                direction={'horizontal'}
                alignItems={'center'}
              >
                <Button
                  target='_blank'
                  variant='normal'
                  href={props.endpoint}
                  data-test-id='preview-button'
                >
                  Preview
                </Button>
                <PreviewGuidance />
              </SpaceBetween>
            )}
            {(manifestBuilt || approved) && (
              <Button
                variant='primary'
                onClick={props.onPublishClick}
                disabled={approved}
                data-test-id='ready-to-publish-button'
              >
                Ready to Publish
              </Button>
            )}
          </SpaceBetween>
        )}
      </Grid>
    </>
  );
};
